import React from "react";
import T from "prop-types";
import { Icon } from "MODULES/shared/components";
import Detail from "./Detail";

export default function CheckForDetail({
  value,
  label,
  className = "text-success",
  icon = "check",
  text = "Yes"
}) {
  const display = value && (
    <span className={className}>
      <Icon name={icon} /> {text}
    </span>
  );

  return <Detail label={label} value={display} />;
}

CheckForDetail.propTypes = {
  className: T.string,
  value: T.bool,
  label: T.string,
  icon: T.string,
  text: T.string
};



// WEBPACK FOOTER //
// ./app/modules/shared/components/DetailTable/CheckForDetail.jsx